import scroller from '../../scroller';
import schema1 from '../scheme/2-2-1';
import schema3 from '../scheme/2-2-3';
import schema5 from '../scheme/2-2-5';
import schema6 from '../scheme/2-2-6';
import illustrationPlanning from '../../illustration-planning';
import illustrationPositioning from '../../illustration-positioning';

let isDesktop = false;
let wrapperDocument = document.querySelector('.chapter-position');
if ($(window).width() >= 1024) {
	isDesktop = true;
}

const $scroller = scroller.getElement();
const $container = wrapperDocument.querySelector('.module-scroll');
const $slides = wrapperDocument.querySelectorAll('.module-scroll .slides');
const $title = wrapperDocument.querySelector('.chapter-fixed__title');
const $headingFirstSlide = $slides[0].querySelector('.chapter-fixed__heading');
const $infoFirstSlide = $slides[0].querySelector('.chapter-fixed__info');
const $figure = wrapperDocument.querySelectorAll('.chapter-fixed__figure');
const $figureCurrentText = wrapperDocument.querySelectorAll('.chapter-fixed__text .line');

const slidesCount = $slides.length;

let isCreated = false;
let increment = null;
let scrollTL = null;
let scrollTr = null;

const setTextShownState = ($figureCurrent) => {
	if ($figureCurrent) {
		$figureCurrent
			// .closest('.slides')
			// .querySelector('.chapter-fixed__text')
			.classList.add('is-shown');
		// console.log($figureCurrent);
	}
};

const changeFigureState = (index, state) => {
	if (index === 0) {
		schema1[state ? 'play' : 'pause']();
	} else if (index === 1) {
		illustrationPositioning[state ? 'play' : 'pause']();
	} else if (index === 2) {
		schema3[state ? 'play' : 'pause']();
	} else if (index === 3) {
		illustrationPlanning[state ? 'play' : 'pause']();
	} else if (index === 4) {
		schema5[state ? 'play' : 'pause']();
	} else if (index === 5) {
		schema6[state ? 'play' : 'pause']();
	}
};

const changeFigureCurrentState = ($figureCurrent, index, state) => {
	if (state) {
		$figureCurrent.isPlaying = true;

		changeFigureState(index, true);
	} else {
		$figureCurrent.isPlaying = false;

		changeFigureState(index, false);
	}
};

const changeFigureStateOnUpdate = () => {
	for (let i = $figure.length - 1; i >= 0; i--) {
		const $figureCurrent = $figure[i];

		const figureBCR = $figureCurrent.getBoundingClientRect();

		if (isDesktop) {
			const figurePartWidth = figureBCR.width / 1.25;

			if (
				figureBCR.left + figurePartWidth <= innerWidth &&
				figureBCR.right - figurePartWidth >= 0 &&
				!$figureCurrent.isPlaying
			) {
				changeFigureCurrentState($figureCurrent, i, true);
			} else if ((figureBCR.left > innerWidth || figureBCR.right < 0) && $figureCurrent.isPlaying) {
				changeFigureCurrentState($figureCurrent, i, false);
			}
		} else {
			const figurePartHeight = figureBCR.height / 4;

			if (
				figureBCR.top + figurePartHeight <= innerHeight &&
				figureBCR.bottom - figurePartHeight >= 0 &&
				!$figureCurrent.isPlaying
			) {
				changeFigureCurrentState($figureCurrent, i, true);
			} else if ((figureBCR.top > innerHeight || figureBCR.bottom < 0) && $figureCurrent.isPlaying) {
				changeFigureCurrentState($figureCurrent, i, false);
			}
		}
	}

	for (let i = $figureCurrentText.length - 1; i >= 0; i--) {
		const $text = $figureCurrentText[i];
		const textBCR = $text.getBoundingClientRect();

		if (
			textBCR.top <= innerHeight * 0.75 &&
			textBCR.bottom >= innerHeight * 0.25 &&
			textBCR.left <= innerWidth * 0.65 &&
			textBCR.right >= innerWidth * 0.35 &&
			!$text.isTextShown
		) {
			$text.isTextShown = true;
			setTextShownState($text);
		}
	}
};

const update = () => {
	if (scrollTL && scrollTL.scrollTrigger) {
		scrollTL.scrollTrigger.refresh();
	}

	if (scrollTr && scrollTr.scrollTrigger) {
		scrollTr.scrollTrigger.refresh();
	}
};

const initSchema = () => {
	schema1.init();
	schema3.init();
	schema5.init();
	schema6.init();
	illustrationPlanning.init();
	illustrationPositioning.init();
};

const create = () => {
	if (isCreated) {
		return;
	}

	let once = false; // костылище

	isCreated = true;
	increment = ($container.scrollWidth - $scroller.clientWidth) / (slidesCount - 1);

	let triggerReset = document.querySelector('.js-reset');
	let triggerResetMobile = document.querySelector('.js-reset-mobile');

	if (isDesktop) {
		scrollTL
			.to($title, {
				duration: 0.2,
				ease: 'none',
				opacity: 0,
				yPercent: -100,
			}, 0)
			.to([$headingFirstSlide, $infoFirstSlide], {
				duration: 0.2,
				ease: 'none',
				y: 0,
			}, 0);

		scrollTr.to(triggerReset, {
			onStart: () => {
				if (!once) {
					initSchema();

					once = true;
				}
			},
		});
	} else {
		scrollTr.to(triggerResetMobile, {
			onStart: () => {
				if (!once) {
					initSchema();

					once = true;
				}
			},
		});
	}

	$slides.forEach(($slideCurrent, slideIndex) => {
		const $infoCurrent = $slideCurrent.querySelector('.chapter-fixed__info');
		const $textCurrent = $slideCurrent.querySelector('.chapter-fixed__text');
		const $figureCurrent = $slideCurrent.querySelector('.chapter-fixed__figure');

		const infoHeight = $infoCurrent.clientHeight;
		const textHeight = $textCurrent.clientHeight;

		if (isDesktop) {
			if (textHeight > infoHeight) {
				const distance = textHeight - infoHeight;

				scrollTL.to($textCurrent, {
					ease: 'none',
					duration: distance * 0.06 / 100,
					y: -distance,
				});
			}

			if (slideIndex < slidesCount - 1) {
				if (slideIndex === 0 || slideIndex === 3) {
					scrollTL.to($container, {
						ease: 'none',
						x: `-=${increment}`,
						delay: 0.1,
					});
				} else {
					scrollTL.to($container, {
						ease: 'none',
						x: `-=${increment}`,
					});
				}

				if ($figureCurrent) {
					scrollTL.to($figureCurrent, {
						ease: 'none',
						xPercent: -20,
					}, '<');
				}
			}
		}
	});

	if (!isDesktop) {
		scroller.getElement().addEventListener('scroll', _throttle(() => {
			if (document.documentElement.dataset.chapters === '2') {
				changeFigureStateOnUpdate();
			}
		}, 100));
	}

	update();
};

const prepare = () => {
	if (isDesktop) {
		scrollTL = gsap.timeline({
			scrollTrigger: {
				onUpdate: _throttle(changeFigureStateOnUpdate, 100),
				trigger: '.module-wrapper',
				pin: true,
				pinType: 'transform',
				pinReparent: false,
				pinSpacing: true,
				start: 'top top',
				end: `+=${$container.offsetWidth * (isDesktop ? slidesCount : 1)}`,
				scrub: 0.5,
				invalidateOnRefresh: true,
				scroller: scroller.getElement(),
			},
		});

		scrollTr = gsap.timeline({
			scrollTrigger: {
				trigger: '.js-reset',
				start: 'top top',
				scroller: scroller.getElement(),
			},
		});
	} else {
		scrollTr = gsap.timeline({
			scrollTrigger: {
				trigger: '.js-reset-mobile',
				start: 'top top',
				scroller: scroller.getElement(),
			},
		});
	}
};

export default {
	prepare,
	create,
	update,
};
